import { RegionShared } from "@1games-ru/region-shared";
import {
  ChatMessageClientRequest,
  ChatMessageClientResponse,
} from "@/core/rpc-mp-provider/messages/chat-message.ts";
import {
  ChatGetCommandsClientResponse,
  ChatSetSettingsClientRequest,
  ChatSetSettingsClientResponse,
} from "@/core/rpc-mp-provider/messages/chat-set-settings";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";
import { ChatMessage } from "@/domains/chat/constants/chat.ts";
import { ChatEvent } from "@/domains/chat/helpers/events";
import { CommonSettings, MessagesSettings } from "@/domains/chat/helpers/settings";

export default class ChatMpProvider {
  public static async sendMessage(
    chatMessage: ChatMessage,
  ): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<ChatMessageClientResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      ChatMessageClientRequest,
      ChatMessageClientResponse
    >("ChatMessageAnyToClient", {
      message: chatMessage,
    });
  }

  public static async setSettings(
    settings: Partial<CommonSettings & MessagesSettings>,
  ): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<ChatSetSettingsClientResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      ChatSetSettingsClientRequest,
      ChatSetSettingsClientResponse
    >(ChatEvent.ChatSetSettingsAnyToClient, settings);
  }

  public static async inputDisable(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.ChatInputDisableResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.ChatInputDisableRequest,
      typeof RegionShared.Client.Responses.ChatInputDisableResponse
    >(RegionShared.Client.Events.Chat.InputDisable, {});
  }

  public static async getCommands(): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<ChatGetCommandsClientResponse>
  > {
    return RpcMpProvider.getInstance().callServer<undefined, ChatGetCommandsClientResponse>(
      ChatEvent.ChatGetCommands,
      undefined,
    );
  }
}
